import Grid from "@mui/material/Grid";
import Sidebar from "./components/sidebar/main";
import Activity from "./components/activity/main";
import { Outlet } from "react-router-dom";
import LayoutHeader from "../../modules/molecules/header/main";
import { Box } from "@mui/material";
import useAppLayout from "../../hooks/useApplayout";
export default function AppLayout() {
  const {
    isSmallScreen,
    sidePanelOpen,
    isMediumScreen,
    isLogedin,
    activityWindowOpened,
    userType,
  } = useAppLayout();

  return (
    <Grid container>
      {!isSmallScreen && (
        <Grid
          item
          sx={{
            flexBasis: sidePanelOpen ? "13.75rem" : "3.1875rem",
            position: "sticky",
            top: 0,
            height: "100vh",
            // transition: "flex-basis 0.2s ease-in-out",
          }}
        >
          <Sidebar sidePanelOpen={sidePanelOpen} />
        </Grid>
      )}
      {/* Main content should occupy available space if the activity window opened
       */}

      <Grid item xs container>
        <Grid item xs={12}>
          <LayoutHeader />
          <Box sx={{ overflowY: "scroll" }}>
            <Outlet />
          </Box>
        </Grid>
      </Grid>
      {!isMediumScreen &&
      isLogedin &&
      activityWindowOpened &&
      userType === "RegenAg" ? (
        <Grid
          item
          sx={{
            flexBasis: "16.75rem",
            borderLeft: "1px solid rgba(0, 0, 0, 0.1)",
          }}
        >
          <Activity />
        </Grid>
      ) : (
        <></>
      )}
    </Grid>
  );
}
